import { EbCommentOnRecipeMeta, EbCommentOnRecipePayload } from 'types/store/EbCommentOnRecipe';
import { createAsyncReducer } from 'utils/Redux';

import { ebCommentOnRecipeActions } from '../actions';

export default createAsyncReducer<EbCommentOnRecipeMeta, EbCommentOnRecipePayload>(ebCommentOnRecipeActions);
